import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

const navItems = [
  { label: "首页", href: "/" },
  { label: "恋爱", href: "/category/lianai" },
  { label: "奇幻", href: "/category/qihuan" },
  { label: "动作", href: "/category/dongzuo" },
  { label: "悬疑", href: "/category/xuanyi" },
  { label: "搞笑", href: "/category/gaoxiao" },
  { label: "恐怖", href: "/category/kongbu" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHome = location.pathname === "/";

  const logoContent = (
    <>
      <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center">
        <i className={`ri-book-open-line text-2xl md:text-3xl ${isHome && !isScrolled ? "text-background-50" : "text-primary-500"}`}></i>
      </div>
      <span className={`font-heading text-xl md:text-2xl font-bold whitespace-nowrap ${isHome && !isScrolled ? "text-background-50" : "text-foreground-950"}`}>
        韩漫头条
      </span>
    </>
  );

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !isScrolled
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur-md"
      }`}
    >
      <nav className="container-page flex items-center justify-between h-16 md:h-20">
        {isHome ? (
          <h1 className="flex items-center gap-2 shrink-0">
            <Link to="/" className="flex items-center gap-2 shrink-0">
              {logoContent}
            </Link>
          </h1>
        ) : (
          <Link to="/" className="flex items-center gap-2 shrink-0">
            {logoContent}
          </Link>
        )}

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === item.href
                  ? "text-primary-500 bg-primary-50"
                  : isHome && !isScrolled
                    ? "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            className={`w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              isHome && !isScrolled
                ? "text-background-50 hover:bg-background-50/10"
                : "text-foreground-600 hover:text-foreground-950 hover:bg-background-100"
            }`}
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
        </div>

        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer ${
            isHome && !isScrolled ? "text-background-50" : "text-foreground-950"
          }`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="菜单"
        >
          <i className={isOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {isOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="container-page py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                onClick={() => setIsOpen(false)}
                className={`px-3 py-2.5 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === item.href
                    ? "text-primary-500 bg-primary-50"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}